import { Vue, Component } from "vue-property-decorator";

@Component({
    name: "analytics",
    components: {},
})
export default class Analytics extends Vue {
    //
}
